module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    ref: "dialog",
    staticStyle: {
      "min-width": "1280px"
    },
    attrs: {
      "title": _vm.导入列
    }
  }, [(_vm.show) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.fields,
      "border": "",
      "max-height": "600"
    },
    on: {
      "selection-change": _vm.selectItem
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "context": _vm._self,
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "width": "300",
      "label": "字段标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "字段名"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e1da40a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Content/abstract/dealConfig/fieldList.vue
// module id = 1769
// module chunks = 2